import React, { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";
import Seo from "../components/Seo";
import { api } from "../lib/api";
import { useCart } from "../lib/cart";
import { gaPurchase } from "../lib/analytics";
import { useContent } from "../context/ContentContext";

export default function PaymentSuccess() {
  const { p } = useContent();
  const c = p("payment_success").states;
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const polls = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let timer;
    const poll = async () => {
      if (polls.current >= 8) { setStatus("pending"); return; }
      polls.current += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          if (!cleared.current) {
            cleared.current = true;
            clear();
            try {
              const last = JSON.parse(localStorage.getItem("camino_last_order") || "null");
              if (last) { gaPurchase(last); localStorage.removeItem("camino_last_order"); }
            } catch { /* ignore */ }
          }
        } else if (["expired", "failed"].includes(r.data.status)) {
          setStatus("error");
        } else {
          timer = setTimeout(poll, 2000);
        }
      } catch {
        timer = setTimeout(poll, 2000);
      }
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="max-w-2xl mx-auto px-5 py-32 text-center min-h-[60vh]" data-testid="payment-success-page">
      <Seo title="Order Confirmed — CaminoSapiens" description="Thank you for your order." noindex />
      {status === "checking" && <p className="text-[#4A4947]">{c.checking}</p>}
      {status === "paid" && (
        <div data-testid="payment-confirmed">
          <div className="mx-auto w-16 h-16 border border-[#1C1B1A] flex items-center justify-center mb-8"><Check className="w-7 h-7" /></div>
          <p className="overline mb-4">{c.paid_eyebrow}</p>
          <h1 className="font-display text-4xl sm:text-5xl">{c.paid_heading}</h1>
          <p className="text-[#4A4947] mt-6 leading-relaxed">
            {c.paid_body}
          </p>
          <Link to={c.paid_link_link} className="inline-block link-underline text-sm mt-8">{c.paid_link_label}</Link>
        </div>
      )}
      {status === "pending" && <div><h1 className="font-display text-3xl">{c.pending_heading}</h1><p className="text-[#4A4947] mt-4">{c.pending_body}</p></div>}
      {status === "error" && <div><h1 className="font-display text-3xl">{c.error_heading}</h1><p className="text-[#4A4947] mt-4">{c.error_body} <Link to="/cart" className="link-underline text-[#B35D4B]">{c.error_link_label}</Link></p></div>}
    </div>
  );
}
